// @flow
import type { Map } from "immutable"

import type { Layover } from "common/records/Journey"

export const getPlaceNameAndCode = (place: Map<string, string>) => {
  const name = place.get("name")
  return `${name}\u00a0${place.get("code")}${
    /[a-zA-Z]+/.test(name) // latin strings have problem with closing parentheses in rtl languages, so we have to add ltr marker
      ? "\u200e"
      : ""
  }`
}

export const getNightsTkey = (layover: Layover, journeyType: string = "") => {
  const place = layover.getIn(["place", "name"])
  const nights = layover.get("nightsInDestination")

  if (layover.get("switchToPlace")) {
    const changePlace = getPlaceNameAndCode(layover.get("switchToPlace"))
    switch (nights) {
      case 0:
        return { tKey: __("result.same_day_return_and_change_to"), values: { place, changePlace } }

      case 1:
        return {
          tKey: __("result.night_in_destination_and_change_to"),
          values: { place, changePlace },
        }

      default:
        return {
          tKey: __("result.nights_in_destination_and_change_to"),
          values: { nights, place, changePlace },
        }
    }
  } else {
    switch (nights) {
      case 0: {
        const tKey =
          journeyType === "multicity"
            ? __("result.same_day_departure")
            : __("result.same_day_return")
        return { tKey, values: { place } }
      }
      case 1:
        return { tKey: __("result.night_in_destination"), values: { place } }

      default:
        return { tKey: __("result.nights_in_destination"), values: { nights, place } }
    }
  }
}
